window.addEventListener('load', () => {
    let toggleMoreLessContainers = document.querySelectorAll('[data-toggle-show-more-less][data-open]');

    for (let toggleMoreLessContainer of toggleMoreLessContainers) {
        let toggle = toggleMoreLessContainer.querySelector('button');

        toggle.addEventListener('click', () => {
            toggleMoreLessContainer.dataset.open === 'false'
                ? (toggleMoreLessContainer.dataset.open = 'true')
                : (toggleMoreLessContainer.dataset.open = 'false');
        });
    }
});
